import React, { useState } from 'react';
import { Check, X } from 'lucide-react';
import GtmBin from './GtmBin';

/* THE PLAN'S OWN ORDER, AND THE ONE DEFINITION OF IT. Q6 is written as Pre-launch / Launch /
   Post-launch and Q5's prerequisites are the step before all three, so 'before' leads and the
   rest follow the document rather than the alphabet.

   It lived in 41_Gtm.jsx, which read it for the launch-stage filter row, while this file carried
   the same four words again as a literal in its dropdown. The filter came off on 2026-10-08 and
   left that copy as the only reader — so the list moved here, where a phase is now chosen, rather
   than being deleted from one file and left duplicated in the other. */
export const PHASES = ['before', 'pre', 'launch', 'post'];

/* AN OPEN ITEM, TYPED WHERE IT WILL SIT.

   Max, 2026-10-07: "ko cần pop up nha cho điền trực tiếp luôn là add line thì sẽ hiện ra các
   trường cần điền trên dòng đó". The same row serves adding and editing — a separate add form is
   how the two drift until one offers a field the other does not — and it lands IN the list, in
   the place the finished row will occupy, rather than over the top of it.

   The KIND leads, because it is what three separate buttons used to ask before anything could be
   typed, and here it can still be changed while the line is being written. */
export default function GtmItemRow({ item, t, onSave, onCancel, busy, draft, onDraft, onRemove }) {
  /* AN EXISTING ROW HAS NO SAVE OF ITS OWN — Max, 2026-10-07, circling it: the sheet already
     carries one, and a second Save on a row is the page asking "which one did you mean". So an
     existing row DRAFTS, through the same map every table cell uses, and the sheet's Save writes
     it. Only a NEW line keeps Add and Cancel, because creating is not editing: nothing exists yet
     to draft against, and an abandoned blank row would be left behind. */
  const adding = !item.item_pk_id;
  const [own, setOwn] = useState({
    kind: item.kind || 'todo',
    title: item.title || '',
    detail: item.detail || '',
    owner_name: item.owner_name || '',
    due_date: (item.due_date || '').toString().slice(0, 10),
    phase: item.phase || '',
  });
  const d = adding ? own : draft;
  const set = (k, v) => (adding ? setOwn((p) => ({ ...p, [k]: v })) : onDraft(k, v));
  const ready = d.title.trim().length > 0;
  const save = () => ready && onSave({
    ...d,
    title: d.title.trim(),
    detail: d.detail.trim() || null,
    owner_name: d.owner_name.trim() || null,
    due_date: d.due_date || null,
    /* Only a to-do carries a phase: a decision belongs to the question that raises it, not to a
       moment in the launch. Cleared rather than left behind when the kind changes. */
    phase: d.kind === 'todo' ? (d.phase || null) : null,
  });

  return (
    /* ONE ROW — Max, 2026-10-07: "tôi muốn có nằm trên 1 hàng". It was three stacked rows (kind
       and title, then the detail, then owner and due), and with every item on the sheet in its
       fields at once that is a wall thirty rows deep. It lays out like the lists above it now:
       one line, one grid, the same reading order. The labels go with it — a one-line row with
       five captions over it is the stack again in smaller type — and each field keeps its
       placeholder and its aria-label, which is what a label was for. */
    <div className={`gtm-itemedit${adding ? ' adding' : ''}`}>
      <select value={d.kind} onChange={(e) => set('kind', e.target.value)}
        aria-label={t('gtm.lineKind')} title={t('gtm.lineKind')}>
        {['todo', 'decision', 'verify'].map((k) => (
          <option key={k} value={k}>{t(`gtm.${k}`)}</option>
        ))}
      </select>
      {/* The placeholder names the KIND, so the box says what it is asking for and keeps saying
          it when the dropdown beside it changes. */}
      <input className="t" autoFocus={adding} value={d.title} placeholder={t(`gtm.${d.kind}`)}
        aria-label={t('gtm.lineTitle')}
        onChange={(e) => set('title', e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && adding) save();
          if (e.key === 'Escape' && adding) onCancel();
        }} />
      <input className="d" value={d.detail} placeholder={t('gtm.lineDetail')}
        aria-label={t('gtm.lineDetail')}
        onChange={(e) => set('detail', e.target.value)} />
      {/* Only a to-do carries a phase; the cell holds its place so the five columns line up down
          the list whatever each row's kind is. */}
      {d.kind === 'todo' ? (
        <select value={d.phase} onChange={(e) => set('phase', e.target.value)}
          aria-label={t('gtm.phaseFilter')} title={t('gtm.phaseFilter')}>
          <option value="">{t('gtm.noPhase')}</option>
          {PHASES.map((x) => (
            <option key={x} value={x}>{t(`gtm.phase_${x}`)}</option>
          ))}
        </select>
      ) : <span className="gtm-itemedit-nophase" aria-hidden="true" />}
      <input list="gtm-people" value={d.owner_name} placeholder={t('gtm.noOwner')}
        aria-label={t('gtm.owner')} title={t('gtm.owner')}
        onChange={(e) => set('owner_name', e.target.value)} />
      <input type="date" value={d.due_date} aria-label={t('gtm.due')} title={t('gtm.due')}
        onChange={(e) => set('due_date', e.target.value)} />
      {adding ? (
        <span className="gtm-itemedit-acts">
          <button type="button" className="gtm-btn small primary" disabled={!ready || busy}
            onClick={save}><Check size={12} /> {t('gtm.add')}</button>
          <button type="button" className="gtm-btn small" onClick={onCancel} disabled={busy}>
            <X size={12} />
          </button>
        </span>
      ) : (
        <span className="gtm-itemedit-acts">
          {/* THE SHARED BIN, one click — Max, 2026-10-08: "click xóa thì xóa luôn chứ". This row
              carried its own ask for an afternoon; the reasoning is in GtmBin, along with what
              the way back is now that nothing stands in front of the delete. */}
          {onRemove && <GtmBin t={t} busy={busy} onRemove={() => onRemove(item)} />}
        </span>
      )}
    </div>
  );
}
